/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureMcaInvoiceSection extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureMcaInvoiceSection");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureMcaInvoiceSection.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureMcaInvoiceSection>): ServiceAccountNativeDetailsForAzureMcaInvoiceSection {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureMcaInvoiceSection(), model);
        ServiceAccountNativeDetailsForAzureMcaInvoiceSection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureMcaInvoiceSection>): ServiceAccountNativeDetailsForAzureMcaInvoiceSection {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureMcaInvoiceSection.newInstance(<ServiceAccountNativeDetailsForAzureMcaInvoiceSection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureMcaInvoiceSection) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureMcaInvoiceSection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureMcaInvoiceSection): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureMcaInvoiceSection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Invoice Section Id
     */
    invoice_section_id: string;

    /**
     * Invoice Section Name
     */
    invoice_section_name: string;

}
